var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-envelope-square';
                    var viewUrl = 'gfx/sprite.svg#view-icon-envelope-square';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };